export const cachedActivityState = state => state.cachedActivityState
export const detailActivityState = state => state.detailActivityState
